import React from 'react'

function DataTable({ data }) {
  if (!data || data.length === 0) {
    return (
      <div className="flex items-center justify-center py-16 text-slate-500">
        No records available
      </div>
    );
  }

  const columns = Object.keys(data[0]);

  return (
    <div className="relative bg-[#0f1c2e] rounded-2xl shadow-[0_20px_50px_rgba(0,0,0,0.08)] overflow-hidden">
      <div className="overflow-x-auto">
        <table className="min-w-full text-left">
          {/* HEADER */}
          <thead className="bg-[#0d1b2e] border-b border-[#1d3350]">
            <tr>
              {columns.map((col) => (
                <th
                  key={col}
                  className="px-6 py-4 text-md font-bold tracking-wide text-slate-500 uppercase"
                >
                  {col.replace(/_/g, " ")}
                </th>
              ))}
            </tr>
          </thead>

          {/* BODY */}
          <tbody className="divide-y divide-slate-100">
            {data.map((row, rowIndex) => (
              <tr
                key={rowIndex}
                className="hover:bg-[#0d1b2e] transition-colors"
              >
                {columns.map((col) => (
                  <td
                    key={col}
                    className="px-6 py-4 text-sm text-slate-300 whitespace-nowrap"
                  >
                    {col === "status" ? (
                      <span
                        className={`inline-flex items-center px-3 py-1 rounded-full text-xs font-medium
                        ${
                          row[col] === "Active"
                            ? "bg-emerald-50 text-emerald-600"
                            : "bg-rose-50 text-rose-600"
                        }`}
                      >
                        {row[col]}
                      </span>
                    ) : (
                      row[col]
                    )}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default DataTable;



